module.exports = __webpack_public_path__ + "img/servicos.403ca959.png";